"use strict";
// (C) 2020-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASHBOARD_HEADER_OVERLAYS_Z_INDEX = exports.DASHBOARD_OVERLAYS_Z_INDEX = void 0;
// Z index of all overlays in Dashboard component
exports.DASHBOARD_OVERLAYS_Z_INDEX = 5000;
// Z index of all overlays in Dashboard header component
exports.DASHBOARD_HEADER_OVERLAYS_Z_INDEX = 6000;
//# sourceMappingURL=zIndex.js.map